export enum shippersTypes {
    SHIPPERS_DATA = 'SHIPPERS_DATA',
    SHIPPERS_CONTACT_DATA="SHIPPERS_CONTACT_DATA",
    SHIPPERS_HOURS_DATA="SHIPPERS_HOURS_DATA",
    SHIPPERS_SAVE = 'SHIPPERS_SAVE',

}